/** Remaining factory-warranty buckets when seller marks warranty = yes. */

export const WARRANTY_REMAINING_ORDER = [
  'under_1m',
  '1_3m',
  '3_6m',
  '6_12m',
  '12m_plus',
  'unknown',
] as const

export type WarrantyRemainingKey = (typeof WARRANTY_REMAINING_ORDER)[number]

export function isWarrantyRemainingKey(v: string | null | undefined): v is WarrantyRemainingKey {
  return !!v && (WARRANTY_REMAINING_ORDER as readonly string[]).includes(v)
}
